$(document).off('chunkLoadErrorOccured').one('chunkLoadErrorOccured', function () {
    let body = $("body");
    let errorMessage = body.data("chunkError");
    if (typeof errorMessage === 'undefined' || errorMessage === "") {
        errorMessage =
            "The application has been updated in the background and the page needs to be reloaded " +
            "for correct functionality. Press ok to refresh now. " +
            "Press cancel if you have unsaved contents you want to backup first and reload manually.";
    }
    let confirm = window.confirm(errorMessage)
    if (confirm === true) {
        location.reload(true)
    }
});